import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconThumbsUp16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconThumbsUp16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 6.997 3.503 6.99a.5.5 0 0 0-.503.5v4.024a.5.5 0 0 0 .5.5H5zm1 5.016h4.941a.5.5 0 0 0 .471-.332l1.434-4.032a.5.5 0 0 0-.471-.668H9V3L6.3 6.6 6 7zm6.375-6.032H10V3c0-.961-1.223-1.369-1.8-.6L5.5 6l-1.992-.01A1.5 1.5 0 0 0 2 7.49v4.023a1.5 1.5 0 0 0 1.5 1.5h7.441c.635 0 1.201-.4 1.414-.997l1.433-4.032a1.5 1.5 0 0 0-1.413-2.003"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconThumbsUp16);
